import React from 'react';
import { Totals } from '../../../../tabs/GainLoss/Components/Totals/Totals';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { useRealizedGainLoss } from '../../../../hooks/useRealizedGainLoss';
import { TotalsLoading } from '../../../../tabs/GainLoss/Components/Totals/Totals.loading';

interface Props {
  title: string;
}

export const RealizedGainLossSummaryCard = ({ title }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const { isFetching, data } = useRealizedGainLoss();

  if (isFetching) {
    return <TotalsLoading isEmbeddedMobile={isEmbeddedMobile} title={title} />;
  }

  if (!data) {
    return null;
  }

  const realizedGainLossTotals = data?.totals;

  if (
    !realizedGainLossTotals ||
    realizedGainLossTotals.shortTerm == null ||
    realizedGainLossTotals.longTerm == null ||
    realizedGainLossTotals.total == null
  ) {
    return null;
  }

  return <Totals gainLossTotals={realizedGainLossTotals} title={title} />;
};
